__turbopack_context__.v({
  "className": "manrope_525adcc4-module__dyLQnG__className",
  "variable": "manrope_525adcc4-module__dyLQnG__variable",
});
